/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
@Injectable({
  providedIn: "root",
})
export class DialogService {
  dialogConfig = new MatDialogConfig();
  constructor(public dialog: MatDialog) {}
  getDialogConfig(position, overrideClass?) {
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = false;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.maxWidth = "100vw";
    this.dialogConfig.width = "100vw";
    this.dialogConfig.maxHeight = "100vh";
    if (overrideClass) {
      this.dialogConfig.panelClass = overrideClass;
    }
    if (Object.keys(position).length) {
      this.dialogConfig.position = position;
    }
    return this.dialogConfig;
  }

  openMatDialog(
    component,
    data?,
    isCenter?,
    givenDialogConfig?,
    isconfirmDialog?: boolean,
    isFull?,
    isLogin?,
    isDetailedBoard?
  ) {
    let dialogConfig = new MatDialogConfig();
    if (isFull) {
      dialogConfig.width = "100vw";
      dialogConfig.height = "100vh";
      dialogConfig.maxWidth = "100vw";
    } else if (!givenDialogConfig && !isconfirmDialog && !isCenter) {
      dialogConfig.panelClass = "mat-dialog-media-query";
      dialogConfig.position = { right: "0" };
    } else if (!isconfirmDialog && !isCenter) {
      dialogConfig = givenDialogConfig;
    } else if (data && data.progress === 0) {
      dialogConfig.position = { bottom: "5vh" };
      dialogConfig.height = "9vh";
      if (window.innerWidth < 959) {
        dialogConfig.width = "90vw";
      } else {
        dialogConfig.width = "33vw";
      }
    } else if (isCenter) {
      if (window.innerWidth < 599 || window.innerHeight < 550) {
        dialogConfig.maxWidth = "100vw";
        dialogConfig.width = "100vw";
        dialogConfig.height = "100vh";
      } else if (window.innerWidth < 1200) {
        dialogConfig.width = "50vw";
        dialogConfig.height = "50vh";
        dialogConfig.minWidth = "450px";
        dialogConfig.minHeight = "550px";
      } else if (isLogin) {
        dialogConfig.width = "30vw";
        dialogConfig.height = "60vh";
      } else if (isDetailedBoard) {
        dialogConfig.maxHeight = "100vh";
        dialogConfig.maxWidth = "100vw";
        dialogConfig.width = "100vw";
        dialogConfig.height = "100vh";
      } else if (data && data.isMedium) {
        dialogConfig.width = "65vw";
        dialogConfig.height = "73vh";
        dialogConfig.minHeight = "500px";
      } else {
        dialogConfig.width = "30vw";
        dialogConfig.height = "75vh";
      }
    } else {
      dialogConfig.maxHeight = "100vh";
      dialogConfig.maxWidth = "100vw";
      if (window.innerWidth < 599) {
        dialogConfig.width = "100vw";
        dialogConfig.height = "100vh";
      } else if (window.innerWidth < 1023 && window.innerWidth > 600) {
        dialogConfig.width = "70vw";
        dialogConfig.height = "15vh";
      } else {
        dialogConfig.width = "55vw";
        dialogConfig.height = "25vh";
      }
      // dialogConfig = this.confirmDialogConfig;
    }
    if (data) {
      dialogConfig.data = data;
    }

    if (data && data.isdisableClose) {
      dialogConfig.disableClose = true;
    } else {
      dialogConfig.disableClose = false;
    }
    return this.dialog.open(component, dialogConfig);
  }
}
